import { create } from 'zustand';

interface OrderProductsReloadStore {
  reloadSignals: Record<string, number>;
  requestReload: (orderId: string) => void;
}

const useOrderProductsReloadStore = create<OrderProductsReloadStore>((set) => ({
  reloadSignals: {},
  requestReload: (orderId) =>
    set((state) => ({
      reloadSignals: {
        ...state.reloadSignals,
        [orderId]: (state.reloadSignals[orderId] ?? 0) + 1,
      },
    })),
}));

export default useOrderProductsReloadStore;
